import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  imports: [RouterOutlet],
  template: ` <router-outlet></router-outlet> `,
})
export class DevComponent {}
